import styles from './tab-slider.module.scss';

interface TabSliderItem {
  title: string;
}

interface TabSliderProps {
  items: TabSliderItem[];
  activeIndex: number;
  onChange: (index: number) => void;
  className?: string;
}

export const TabSlider = ({ items, activeIndex, onChange, className }: TabSliderProps) => {
  return (
    <div className={`${styles.slider} ${className ?? ''}`}>
      <div className={styles.slider__inner}>
        {items.map((item, index) => (
          <button
            key={item.title}
            type="button"
            className={index === activeIndex ? styles.slider__button_active : styles.slider__button}
            onClick={() => onChange(index)}
          >
            {item.title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabSlider;
